/* ─── Root ─── */

.root {
  overflow: hidden;
}

/* ─── Viewport ─── */

.viewport {
  overscroll-behavior: contain;
}

/* ─── Scrollbar ─── */

.scrollbar {
  display: flex;
  width: 6px;
  padding: 1px;
  opacity: 0;
  transition: opacity var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.scrollbar[data-hovering],
.scrollbar[data-scrolling] {
  opacity: 1;
}

.horizontal {
  width: auto;
  height: 6px;
  flex-direction: row;
}

/* ─── Thumb ─── */

.thumb {
  flex: 1;
  background: var(--md-outline-variant);
  border-radius: var(--shape-full);
}

@media (hover: hover) {
  .thumb:hover {
    background: var(--md-outline);
  }
}

/* ─── Corner ─── */

.corner {
  background: var(--md-outline-variant);
}
